import * as React from 'react';

import AssignActivityPackBanner from '../assignActivityPackBanner';
import { requestPut, } from '../../../../../modules/request/index';
import GradeLevelSection from '../shared/grade_level_section';
import SubjectAreaSection from '../shared/subject_area_section';
import { useABTest, } from '../../../../Shared/utils/posthog';
import { COLLEGE_INSTITUTION_TYPE, redirectTo, } from '../../../../Shared/index';

const teacherAtBoardSrc = `${window.postbuildEnv.CDN_URL}/images/onboarding/packs-whole.svg`

const AddTeacherInfo = ({ subjectAreas, school, subscription, userId }) => {
  const [minimumGradeLevel, setMinimumGradeLevel] = React.useState(null)
  const [maximumGradeLevel, setMaximumGradeLevel] = React.useState(null)
  const [selectedSubjectAreaIds, setSelectedSubjectAreaIds] = React.useState([])

  const isCollege = school?.institution_type === COLLEGE_INSTITUTION_TYPE

  const runABTest = useABTest(
    {
      flagKey: 'onboarding-tour-ab-test',
      handler: (variant) => {
        if (variant === 'tour-flow') {
          redirectTo('/sign-up/tour')
        } else {
          redirectTo('/finish_sign_up')
        }
      },
      userId: userId
    }
  );

  function submitTeacherInfo() {
    const teacherInfoParams = isCollege
      ? { subject_area_ids: selectedSubjectAreaIds }
      : {
        minimum_grade_level: minimumGradeLevel.value,
        maximum_grade_level: maximumGradeLevel.value,
        subject_area_ids: selectedSubjectAreaIds
      }
    requestPut(
      `${window.postbuildEnv.DEFAULT_URL}/teacher_infos`,
      teacherInfoParams,
      (body) => {
        if (subscription) {
          redirectTo('/finish_sign_up')
        } else {
          runABTest()
        }
      }
    )
  }

  const nextButtonClassName = "quill-button-archived primary contained medium focus-on-light"
  let nextButton = <button className={`${nextButtonClassName} disabled`} disabled type="button">Next</button>

  if (selectedSubjectAreaIds.length && (isCollege || (minimumGradeLevel && maximumGradeLevel))) {
    nextButton = <button className={nextButtonClassName} onClick={submitTeacherInfo} type="button">Next</button>
  }

  const teachingTopics = isCollege ? 'subjects' : 'grade level and subjects'

  return (
    <div>
      <AssignActivityPackBanner />
      <div className="container account-form add-teacher-info">
        <img alt="" src={teacherAtBoardSrc} />
        <h1>{`Now select the ${teachingTopics} you teach`}</h1>
        <p className="sub-header">Sharing the {teachingTopics} you teach helps us make better decisions about what kind of content to create and what new product features to build. The more information we have, the better we can support you and your students!</p>
        {!isCollege && (
          <section className="user-account-section grade-level-section">
            <h2>Grade Level</h2>
            <GradeLevelSection
              maximumGradeLevel={maximumGradeLevel}
              minimumGradeLevel={minimumGradeLevel}
              setMaximumGradeLevel={setMaximumGradeLevel}
              setMinimumGradeLevel={setMinimumGradeLevel}
            />
          </section>
        )}
        <section className="user-account-section subject-area-section">
          <h2>Subject Areas</h2>
          <SubjectAreaSection
            selectedSubjectAreaIds={selectedSubjectAreaIds}
            setSelectedSubjectAreaIds={setSelectedSubjectAreaIds}
            subjectAreas={subjectAreas}
          />
        </section>
        <div className="button-wrapper">
          {nextButton}
        </div>
      </div>
    </div>
  )
}

export default AddTeacherInfo
